import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  storeMenuButton,
  storeMenuItems,
  storeStockList,
} from "../../services/tableQRServices";
import _, { get } from "lodash";
import Carousel from "react-multi-carousel";
import { useNavigate } from "react-router-dom";
import RecommendationItems from "./recommendationItems";
import { addToCart } from "../../redux/cartSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import UpsellingModal from "../../component/Upselling/UpsellingModal";
import getUpsellingItems from "../../utils/getUpsellingitems";
import MenuDetail from "../category/MenuDetail";
import useBrandConfig from "../../hooks/useBrandConfig";
import usePromotion from "../../hooks/usePromotion";
import { CustomizeModal } from "../category/CustomizeModal";
import { setOpenConfetti, setOpenLottieAddCart } from "../../redux/appSlice";
import { STORAGEKEY } from "../../constants";

function Recommendation({ responsive, supaProducts, onDispatchCartTax }) {
  const navigate = useNavigate();
  const dispatcher = useDispatch();
  const [showUpsellingModal, setShowUpsellingModal] = useState(false);
  const [upsellingItems, setUpsellingItems] = useState([]);
  const [showModalData, setShowModalData] = useState([]);
  const [showCustomizeModal, setShowCustomizeModal] = useState(false);
  const [selectedItem, setSelectedMenuItem] = useState({});
  const [showDetailModal, setShowDetailModal] = useState(false);
  const { config, recommendations } = useBrandConfig();
  const cartItems = useSelector((state) => state.cart.cart);

  const { handleConvertPromotionItem } = usePromotion();

  const { posStoreStockList, posMenuButton, posFullItemList } = useSelector(
    (state) => state.pos
  );

  const getMenuTypeGrouped = useCallback((data) => {
    return (get(data, "itemmaster_menutype_grpdtls", []) || [])
      .slice()
      .sort((a, b) => a.item_menutype_grpdtls - b.item_menutype_grpdtls)
      .map((menuTypeGroup, i) => menuTypeGroup);
  }, []);

  const selectedDineOption = localStorage.getItem(STORAGEKEY.DINING_MODE);

  const isDineIn = useMemo(
    () => selectedDineOption === "dinein",
    [selectedDineOption]
  );

  const placeOrder = async (dishDetail) => {
    if (
      dishDetail.itemmaster_menutype_grpdtls === "" // temp fix
      // dishDetail.itemmaster_menutype_grpdtls === "" ||
      // menuTypeDtls?.every((record) => record?.length === 1)
    ) {
      let addOnValues = [];
      const menuTypeDtls = getMenuTypeGrouped(dishDetail)?.map(
        (menuTypeGroup) =>
          dishDetail?.itemmaster_menutypedtls.filter(
            (customItems) =>
              customItems.modifier_name === menuTypeGroup.modifier_name
          )
      );

      menuTypeDtls?.forEach((childMenuTypeDtls) => {
        childMenuTypeDtls?.forEach((addOnData) => {
          addOnValues.push({
            modifier_qty: 1,
            item_no: addOnData.citem_no,
            modifier_name: addOnData.modifier_name,
            citem_name: addOnData.citem_name,
            price_dtls: isDineIn
              ? addOnData.price_dtls[0].dine_in_price
              : addOnData.price_dtls[0].takeaway_price,
            sku_no: addOnData.citem_no.replace("PRD", "SKU"),
            uom: addOnData.uom,
          });
        });
      });

      addOnValues.reverse();

      const itemInCart = cartItems.find(
        (item) =>
          item.id === dishDetail.item_no &&
          item.addOnValues.length === 0 &&
          _.isEqual(_.map(item.addOnValues, "item_no"), _.map([], "item_no")) &&
          !item.item.isFree
      );

      dispatcher(
        addToCart(
          handleConvertPromotionItem({
            uuid: itemInCart?.uuid,
            id: dishDetail.item_no,
            addOnValues,
            item: dishDetail,
            qty: 1,
            price: dishDetail.selling_uom_dtls[0]?.price_dtls[0]?.dine_in_price,
          })
        )
      );
      if (config?.enableLottie) {
        dispatcher(setOpenLottieAddCart(true));
      }
      toast.success(`${dishDetail.item_name}  ADDED TO CART`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
      const { hasUpsellingItems, items: upsellItems } = await getUpsellingItems(
        dishDetail.category_code,
        dishDetail.item_category
      );
      if (hasUpsellingItems) {
        setUpsellingItems(upsellItems);
        setShowUpsellingModal(true);
      }
    } else {
      const customDetails = {
        item: dishDetail,
      };

      if (config?.usingCustomizePage) {
        navigate("/customize-dish", {
          state: customDetails,
        });
      } else {
        setShowModalData(customDetails);
        setShowCustomizeModal(true);
      }
    }
  };

  const [gochiMenuItems, setGochiMenuItems] = useState([]);

  const itemsListAndCategory = () => {
    const resultParse = JSON.parse(posStoreStockList);

    let categoryCodes = [];
    for (const category of resultParse.filter(
      (category) => category.avl_type === "C"
    )) {
      categoryCodes.push(category.item_category);
    }
    let resultItemsParsed = resultParse.filter(
      (category) => category.avl_type === "I"
    );
    menuButtonFunction(
      categoryCodes,
      resultItemsParsed,
      resultParse?.filter(
        (item) => item.is_emenu_disable === "N" && item.is_soldout === "N"
      )
    );
  };

  const menuButtonFunction = (
    categoryCodes,
    resultItemsParsed,
    resultParse
  ) => {
    const categoryMenuButton = posMenuButton;

    let categoryMainMenuButton = categoryMenuButton.filter(
      (menuItem) => menuItem.root_category_code === "MAIN"
    );
    if (categoryMainMenuButton && categoryMainMenuButton.length > 0) {
      categoryMainMenuButton = categoryMainMenuButton[0];
      let categoriesIndex = categoryMainMenuButton.category || [];

      // ? Sort on sequences and filter on start and end time
      categoriesIndex = [...categoriesIndex]
        .sort((a, b) => a.course_seq - b.course_seq)
        .filter(
          (category) =>
            category.start_time <= moment().format("HH:mm:ss") &&
            category.end_time > moment().format("HH:mm:ss")
        );

      categoryCodes = [];
      for (const category of categoriesIndex) {
        categoryCodes.push(category.category_code);
      }
      let menuItemsArray = [];
      for (const category of categoryCodes) {
        const catItem = categoryMenuButton.filter(
          (catItems) => catItems.root_category_code === category
        );
        if (
          catItem &&
          catItem.length > 0 &&
          catItem[0].items &&
          catItem[0].items.length > 0
        ) {
          menuItemsArray.push(...catItem[0].items);
        }
      }
      // ? Intersect items from stock and button api
      let intersectCategory = _.intersectionBy(
        resultItemsParsed,
        menuItemsArray,
        (obj) => obj.item_category || obj.item_no
      );
      // ? Intersect items from with intersected items and button api items
      intersectCategory = Object.values(
        _.merge(
          _.keyBy(intersectCategory, "item_category"),
          _.keyBy(menuItemsArray, "item_no")
        )
      ).filter(
        (item) =>
          item.is_soldout === "N" &&
          item.is_emenu_disable === "N" &&
          item.start_time <= moment().format("HH:mm:ss") &&
          item.end_time > moment().format("HH:mm:ss")
      );
      menuItemsFunction(intersectCategory, categoryCodes, resultParse);
    }
  };

  const menuItemsFunction = (intersectCategory, categoryCodes, resultParse) => {
    const result = posFullItemList;

    const filterItemMaster = result.filter(
      (item) =>
        item.itemmaster_menutypedtls && item.itemmaster_menutypedtls.length > 0
    );

    const stockedCheckedItem = [];
    if (filterItemMaster && filterItemMaster.length > 0) {
      for (const itemMaster of filterItemMaster) {
        let itemmaster_menutypedtls = [];
        for (const typeDtls of itemMaster.itemmaster_menutypedtls) {
          const modifierQty = resultParse.filter(
            (itemCategory) => itemCategory.item_no === typeDtls.citem_no
          );
          const findItem = resultParse?.find(
            (record) => record?.item_no === typeDtls.citem_no
          );
          const checkingDisabledMenu =
            findItem?.is_emenu_disable === "N" && findItem?.is_soldout === "N";

          if (checkingDisabledMenu) {
            if (modifierQty && modifierQty.length > 0) {
              itemmaster_menutypedtls.push({
                ...typeDtls,
                is_soldout: modifierQty[0].is_soldout,
                is_emenu_disable: modifierQty[0].is_emenu_disable,
                is_avl_limit_check: modifierQty[0].is_avl_limit_check,
                bal_qty: modifierQty[0].bal_qty,
              });
            } else {
              itemmaster_menutypedtls.push({ ...typeDtls });
            }
          } else if (!findItem) {
            itemmaster_menutypedtls.push({ ...typeDtls });
          }
        }

        const findStockedItem = resultParse?.find(
          (record) => record?.item_category === itemMaster?.item_no
        );

        if (findStockedItem) {
          stockedCheckedItem.push({
            ...findStockedItem,
            ...itemMaster,
            itemmaster_menutypedtls,
          });
        }
      }
    }
    const filterNoItemMaster = result.filter(
      (item) =>
        !item.itemmaster_menutypedtls ||
        item.itemmaster_menutypedtls.length <= 0
    );

    const combineItems = [];

    [...filterNoItemMaster, ...stockedCheckedItem].forEach((record) => {
      const findStockedItem = resultParse?.find(
        (item) => (item?.item_category || item?.item_no) === record?.item_no
      );

      if (findStockedItem) {
        combineItems.push({
          ...findStockedItem,
          ...record,
        });
      }
    });

    let intersectItems = _.intersectionBy(
      intersectCategory,
      combineItems,
      (obj) => obj.item_category || obj.item_no
    ).filter((item) => item.is_active);

    intersectItems = Object.values(
      _.merge(
        _.keyBy(intersectCategory, "item_category"),
        _.keyBy(combineItems, "item_no")
      )
    )
      .filter(
        (item) => item.is_active && categoryCodes.includes(item.category_code)
      )
      .filter(
        (item) => item.is_emenu_disable === "N" && item.is_soldout === "N"
      )
      .filter((record) =>
        !recommendations?.length
          ? true
          : recommendations
              ?.map((item) => item?.id)
              ?.includes(record?.category_code)
      );

    const listItemCategory = intersectCategory?.map(
      (record) => record.item_category || record.item_no
    );
    const newCombineItems = combineItems
      ?.filter(
        (record) =>
          !listItemCategory.includes(record.item_category || record.item_no)
      )
      .filter(
        (item) => item.is_emenu_disable === "N" && item.is_soldout === "N"
      );

    let newResultItemsParsed = newCombineItems.filter((record) =>
      !recommendations?.length
        ? true
        : recommendations
            ?.map((item) => item?.id)
            ?.includes(record?.category_code)
    );

    if (!newResultItemsParsed?.length) {
      newResultItemsParsed = newCombineItems;
    }

    console.log("newResultItemsParsed", newResultItemsParsed);
    console.log("intersectItems", intersectItems);
    console.log("recommendations", recommendations);

    if (recommendations?.length > 0 && intersectItems?.length < 10) {
      if (newResultItemsParsed?.length > 0) {
        let retryCount = 0;

        while (intersectItems?.length < 10) {
          const randomItem =
            newResultItemsParsed?.[
              parseInt(Math.random() * (newResultItemsParsed.length - 1))
            ];
          const checkingExistItem = intersectItems?.find(
            (record) => record?.item_no === randomItem?.item_no
          );

          if (!checkingExistItem) {
            intersectItems.push(randomItem);
          }

          retryCount++;

          if (retryCount === 10) {
            break;
          }
        }
      }
    }

    const sortAlphabetically = intersectItems.sort((a, b) =>
      a?.item_desc?.localeCompare(b?.item_desc)
    );

    const sortByCategory = sortAlphabetically.sort(
      (a, b) =>
        categoryCodes.indexOf(a.category_code) -
        categoryCodes.indexOf(b.category_code)
    );

    setGochiMenuItems(sortByCategory);
  };

  const handleCustomModalSuccessSubmit = async (submittedItem) => {
    const { hasUpsellingItems, items: upsellItems } = await getUpsellingItems(
      submittedItem.category_code,
      submittedItem.item_category
    );
    if (hasUpsellingItems) {
      setUpsellingItems(upsellItems);
      setShowUpsellingModal(true);
    }
  };

  const toggleDetailModal = (data = {}) => {
    setSelectedMenuItem(data);
    if (showDetailModal) {
      setShowDetailModal(false);
    } else {
      setShowDetailModal(true);
    }
  };

  useEffect(() => {
    itemsListAndCategory();
  }, []);

  return (
    <>
      <Carousel
        showDots={false}
        responsive={responsive}
        ssr={false} // means to render carousel on server-side.
        infinite={false}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        className="flex gap-2"
        containerClass="carousel-container flex gap-2"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px">
        {gochiMenuItems &&
          Object.keys(supaProducts)?.length > 0 &&
          gochiMenuItems.map((sliderdata, index) => {
            return (
              <RecommendationItems
                key={index}
                sliderdata={sliderdata}
                index={index}
                placeOrder={placeOrder}
                onDetailOpen={toggleDetailModal}
                supaProducts={supaProducts}
                onDispatchCartTax={onDispatchCartTax}
              />
            );
          })}
      </Carousel>
      {showDetailModal ? (
        <MenuDetail
          show={showDetailModal}
          onHide={toggleDetailModal}
          data={selectedItem}
          placeOrder={placeOrder}
        />
      ) : null}
      {showUpsellingModal ? (
        <UpsellingModal
          show={showUpsellingModal}
          handleClose={() => setShowUpsellingModal(false)}
          recommendationItems={upsellingItems}
        />
      ) : null}
      {showCustomizeModal ? (
        <CustomizeModal
          showModal={showCustomizeModal}
          setShowModal={setShowCustomizeModal}
          showModalData={showModalData}
          onSuccessSubmit={handleCustomModalSuccessSubmit}
        />
      ) : null}
    </>
  );
}

export default Recommendation;
